/**
 * Lectura de cookies en el cliente.
 *
 * Existía tres veces: `pending-character.ts` y `country-cookie.ts` con el mismo
 * `split('; ').find(...).slice(...)` carácter por carácter, y
 * `auth-operations.ts` con una variante peor (`.split('=')[1]`, que trunca en el
 * primer `=` del valor). Una sola.
 *
 * Devuelve el valor **crudo**: quién lo lee decide si necesita
 * `decodeURIComponent` (y el `try/catch` que eso obliga — `decodeURIComponent('%')`
 * lanza `URIError`). Para valores que no llevan escapes, lo correcto es no
 * decodificar.
 */
export function readCookie(name: string): string | undefined {
  if (typeof document === 'undefined') return undefined

  return document.cookie
    .split('; ')
    .find((entry) => entry.startsWith(`${name}=`))
    ?.slice(name.length + 1)
}
